import React, { useState } from "react";
import { auth } from "../firebase";
import { signInWithEmailAndPassword } from "firebase/auth";
import "./AdminLogin.css";

export default function AdminLogin() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    async function handleLogin(e) {
        e.preventDefault();
        setError("");
        setLoading(true);
        try {
            await signInWithEmailAndPassword(auth, email, password);
        } catch (err) {
            setError("Invalid credentials. Please try again.");
        }
        setLoading(false);
    }

    return (
        <div className="admin-login-bg">
            <div className="admin-login-card">
                <div className="admin-login-logo">
                    <img
                        src="https://pe56d.s3.amazonaws.com/o_1j7cpvf4dh1f1h3djaa1jja2hln.png"
                        alt="LB Books"
                    />
                </div>
                <h1>Admin Portal</h1>
                <p className="admin-login-sub">LB Books — Internal Dashboard</p>

                {error && <div className="admin-login-error">{error}</div>}

                <form onSubmit={handleLogin} className="admin-login-form">
                    <div className="admin-field">
                        <label>Email</label>
                        <input
                            type="email"
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                            placeholder="admin@lbbooks.com"
                            required
                            autoFocus
                        />
                    </div>
                    <div className="admin-field">
                        <label>Password</label>
                        <input
                            type="password"
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                            placeholder="••••••••"
                            required
                        />
                    </div>
                    <button type="submit" className="admin-login-btn" disabled={loading}>
                        {loading ? "Signing in…" : "Sign In"}
                    </button>
                </form>
            </div>
        </div>
    );
}
